import { render } from "./EditingSectionUnknown.vue?vue&type=template&id=1133ea5f"
const script = {}
script.render = render

export default script